import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';

import { Full_ROUTES } from './shared/routes/full-layout.routes';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';


// @ts-ignore
import { LoginGuardService } from './shared/auth/login-guard';
import { LoginRedirectComponent } from './components/login-redirect';
import { AuthService } from './shared/auth/auth.service';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'danhmuc/bang-gia',
    pathMatch: 'full',
    canActivate: [LoginGuardService],
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: { title: 'full Views' },
    children: Full_ROUTES,
    canActivate: [LoginGuardService] },
  {
    path: '', component: ContentLayoutComponent,
    data: { title: 'content Views' },
    children: CONTENT_ROUTES,
    canActivate: [LoginGuardService]},
  {
    path: '**',
    redirectTo: 'pages/error',
    canActivate: [LoginGuardService],
  },
  { path: 'login-redirect.html', component: LoginRedirectComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
  providers: [LoginGuardService, AuthService]
})

export class AppRoutingModule {
}
